var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { forwardRef, useState, useCallback } from "react";
import { Label } from "../../Label";
import TextInput from "../TextInput";
import { TextFieldWrap, RequiredMessage } from "./styled";
import { generateTestId } from "../../../utils";
// https://github.com/styleguidist/react-styleguidist/issues/1421
export var TextField = forwardRef(function (_a, ref) {
    var _b = _a.hasReadModeStyles, hasReadModeStyles = _b === void 0 ? false : _b, label = _a.label, labelAttributes = _a.labelAttributes, isRequired = _a.isRequired, onFocus = _a.onFocus, onBlur = _a.onBlur, id = _a.id, className = _a.className, style = _a.style, inputHTMLAttributes = _a.inputHTMLAttributes, rest = __rest(_a, ["hasReadModeStyles", "label", "labelAttributes", "isRequired", "onFocus", "onBlur", "id", "className", "style", "inputHTMLAttributes"]);
    var _c = __read(useState(hasReadModeStyles), 2), isReadMode = _c[0], setIsReadMode = _c[1];
    var _d = rest.hasError, hasError = _d === void 0 ? false : _d;
    var _onFocus = useCallback(function (e) {
        setIsReadMode(false);
        if (onFocus)
            onFocus(e);
    }, [onFocus]);
    var _onBlur = useCallback(function (e) {
        setIsReadMode(hasReadModeStyles);
        if (onBlur)
            onBlur(e);
    }, [hasReadModeStyles, onBlur, setIsReadMode]);
    return (React.createElement(TextFieldWrap, { id: id, className: className, style: style },
        label && (React.createElement(Label, __assign({ hasReadModeStyles: hasReadModeStyles }, labelAttributes, { htmlFor: inputHTMLAttributes === null || inputHTMLAttributes === void 0 ? void 0 : inputHTMLAttributes.id }),
            React.createElement(React.Fragment, null,
                label,
                isRequired && !isReadMode && (React.createElement(RequiredMessage, __assign({ "$hasError": hasError }, generateTestId("label-required"), generateTestId(hasError
                    ? "label-required-error"
                    : "label-required-no-error")), "(required)"))))),
        React.createElement(TextInput, __assign({ ref: ref, hasError: hasError, onFocus: _onFocus, onBlur: _onBlur, isReadMode: isReadMode, hasReadModeStyles: hasReadModeStyles }, inputHTMLAttributes, rest))));
});
TextField.displayName = "TextField";
export default TextField;
//# sourceMappingURL=index.js.map